import { ButtonDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../redux/hooks";
import { selectOnboardingLinkCooldownDriverUuids } from "../../linkyConsentsSlice";
import { LinkyConsentApi } from "../../linkyConsentsAPI";
import { useSendDriverOnboardingLink } from "../../useSendDriverOnboardingLink";
import "../../../../../i18n/i18n";

export const SidePanelSendLink = (props: { driver: LinkyConsentApi }) => {
  const { t } = useTranslation();
  const { driver } = props;
  const cooldownDriverUuids = useAppSelector(
    selectOnboardingLinkCooldownDriverUuids,
  );
  const onResend = useSendDriverOnboardingLink();

  const isDisabled =
    (!!driver.consentLinkExpiresAt &&
      new Date(driver.consentLinkExpiresAt) > new Date()) ||
    cooldownDriverUuids.includes(driver.uuid);

  return (
    <ButtonDS
      text={t("linky_consents.action.resend")}
      format="fill"
      buttonType="secondary"
      onClick={isDisabled ? undefined : () => onResend(driver.uuid)}
      disabled={isDisabled}
    />
  );
};
